import { mainApi } from "../providers/api";
import React, { useState, useEffect } from "react";
import { useLocation, useParams } from "react-router-dom";
import objectPath from "object-path";
import SignItem from "./components/Sign";
import Loading from "../components/Loading";

const Type = () => {
  const { id } = useParams();
  const location = useLocation();
  console.log(location.state); // 'John'

  const [data, setdata] = useState();
  const [loading, setloading] = useState(false);
  const [offset, setoffset] = useState(0);
  useEffect(() => {
    const fetch = async () => {
      try {
        setloading(true);

        const result = await mainApi({
          url: `/service/sign`,
          method: `POST`,
          auth: {
            username: "hsct",
            password:
              "769a9a905bbd4046903581605db75cad20fe84c70868d9874a628f09347c47df",
          },
          data: {
            find: {
              type: id,
            },
            offset: offset,
            limit: 20,
          },
        });
        console.log("re", result.data.items);
        setdata(result.data.items);
        setloading(false);
      } catch (err) {
        setloading(false);
        console.log("err", err);
      }
    };

    fetch();
  }, [id]);

  return (
    <div className="flex flex-col p-4 w-full pb-32">
      <div className="p-2 font-medium text-2xl">
        {objectPath.get(location, "state.name")}
      </div>
      <div className="flex flex-wrap w-full justify-center md:justify-start">
        {loading ? (
          <Loading width="w-16" />
        ) : (
          data?.map((row, index) => {
            return <SignItem key={index} data={row} />;
          })
        )}
      </div>
    </div>
  );
};

export default Type;
